/**
 * Created by YLM on 2020/09/01
 * */

export default {
  namespaced: true,
  state: {

    // 用户token
    user_token: '',

    // '_' + 户型ID
    house_id: '_0',

    // 选中的商品
    selected: [],

  },
  getters:{

    // 获取选中商品
    getSelected (state) {
      state.selected = JSON.parse(localStorage.selectedProducts || '{}')
      if(!state.selected[state.house_id]) state.selected[state.house_id] = []
      return state.selected[state.house_id]
    },

    // 获取已选中的已选商品
    getCheckedProducts(s){
      s.selected = JSON.parse(localStorage.selectedProducts || '{}')  // 在方法内再修改state内值才会触发更新
      if(!s.selected[s.house_id]) s.selected[s.house_id] = []
      let list = s.selected[s.house_id]
      let list_ = []
      list.forEach(p=>{
        if(p.checked) list_.push(p)
      })
      return list_
    },

    // 获取未选中的商品
    getUncheckProducts(s){
      s.selected = JSON.parse(localStorage.selectedProducts || '{}')   // 在方法内再修改state内值才会触发更新
      if(!s.selected[s.house_id]) s.selected[s.house_id] = []
      let list = s.selected[s.house_id]
      let list_ = []
      list.forEach(p=>{
        if(!p.checked) list_.push(p)
      })
      return list_
    },

    // 已选商品价格
    getPrice(s){
      let list = s.selected[s.house_id]
      let price = {
        discount: 0,
        original: 0,
        diff: 0
      }

      if(!list || list.constructor.name !== 'Array') list = []
      list.forEach(p=>{
        if(p.checked){
          price.discount = (+price.discount + (+p.discount_price)).toFixed(2)
          price.original = (+price.original + (+p.original_price)).toFixed(2)
          price.diff = (+price.original - (+price.discount)).toFixed(2)
        }
      })

      return price
    },

    // --- 内部方法 ---

    // 获取 当前户型已选商品列表
    _getSelected(s){
      s.selected = JSON.parse(localStorage.selectedProducts || '{}')
      return s.selected[s.house_id]
    },

  },
  mutations: {

    // 设置当前户型id
    setHouseId(state, {houseId, userToken}){
      state.house_id = '_' + houseId

      if(localStorage.sel_pro_user !== userToken) {
        localStorage.selectedProducts = '{}'
        state.selected = {}
      }

      localStorage.sel_pro_user = userToken
    },

    // 删除选中的商品
    delSelected(s, arr){
      let list = this.getters["selPro/getSelected"]
      for(let j in arr){
        for(let i=0; i < list.length; i++){
          if(list[i].id === arr[j]){
            list.splice(i, 1)
            i--
          }
        }
      }
      this.commit('selPro/_updateSelected')
    },

    // 添加选中的商品
    addSelected(s, arr){
      let list = this.getters["selPro/getSelected"]
      list.unshift(...arr)
      this.commit('selPro/_updateSelected')
    },

    // 标记选中
    check(s, {idArr, checked}){
      let list = this.getters["selPro/getSelected"]
      for(let i in list){
        for(let j in idArr){
          if(idArr[j] === list[i].id) Object.assign(list[i], { checked })
        }
      }
      this.commit('selPro/_updateSelected')
    },

    // 更新未选中
    update(s){
      let list = this.getters["selPro/getSelected"]
      for(let i=0; i < list.length; i++){
        if(!list[i].checked){
          list.splice(i, 1)
          i--
        }
      }
      this.commit('selPro/_updateSelected')
    },

    // --- 内部调用 ---

    // 更新 当前户型已选商品列表
    _updateSelected(s){
      localStorage.selectedProducts = JSON.stringify(s.selected)
    },

  }
}
